konnyScript(function($){
    $('#knPrdCon .bibFreeEvent').click(function(){
        $('#knPrdCon .bibFreePopUp').addClass('active');
        $('body').addClass('popOpen');
    });
    $('#knPrdCon .bibFreePopUp .bgLayer').click(function(){
        $('#knPrdCon .bibFreePopUp').removeClass('active');
        $('body').removeClass('popOpen');
    });
    $('#knPrdCon .bibFreePopUp .closeBt').click(function(){
        $('#knPrdCon .bibFreePopUp').removeClass('active');
        $('body').removeClass('popOpen');
    });
    
    $('#knPrdCon .qnaInfo header').click(function(){
    	$(this).toggleClass('active');
    });
    
    
    //몰컷 슬라이드_25FW
    $('[id^=\'mall_26ss_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage = this.querySelector('.swiper-pagination');
        var slideScr = this.querySelector('.swiper-scrollbar');
        var mallSlide = new Swiper(this,{
            slidesPerView:'auto',
            slidesPerGroup:1,
            spaceBetween:10,
            centeredSlides:false,
            scrollbar:{
                el:slideScr,
            },
        });
    });

    /* gif 슬라이드 */
    $('[id^=\'bgGif_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage = this.querySelector('.swiper-pagination');
        var slideScr = this.querySelector('.swiper-scrollbar');
        var gifSlide = new Swiper(this,{
            slidesPerView:1,
            slidesPerGroup:1,
            centeredSlides:true,
            loop:true,
            effect:'fade',
            speed:0,
            autoplay:{
                delay:600,
                disableOnInteraction:false,
            },
        });
    });
    
})